import React, { useEffect, useState, useLayoutEffect, useRef } from 'react';
import './PwsOwnerInfoCertifiedDynamicLogo.scss';
import isDistributorCertified from './isDistributorCertified';
import t from 'rcm-i18n';
import jquery from 'jquery';
interface Props {
    ownerUserId: string;
}
const PwsOwnerInfoCertifiedDynamicLogo = (props: Props) => {

    const [isCertified, setIsCertified] = useState(false);
    const imageRef = useRef<HTMLImageElement>(null);
    useEffect(() => {
        isDistributorCertified(props.ownerUserId).then((isCertifiedValueFromServer) => {
            setIsCertified(isCertifiedValueFromServer);
        });
    }, []);
    useLayoutEffect(() => {
        // Enable faster better looking Bootstrap 3 tool tips
        if (isCertified) {
            // @ts-ignore
            jquery(imageRef.current).tooltip();
        }
    }, [isCertified]);
    return <>
        {isCertified &&
            <img
                ref={imageRef}
                data-toggle="tooltip" // Bootstrap 3
                data-placement="bottom" // Bootstrap 3
                title={t('Certified')}
                className="PwsOwnerInfoCertifiedDynamicLogo"
                src="https://reliv-static.s3-us-west-2.amazonaws.com/art/WebStuff/PersonalWebsites/2020/Certified/CertifiedIcon-web.svg" />
        }
    </>;
};
export default PwsOwnerInfoCertifiedDynamicLogo;
